<section class="app-card" [ngClass]="['app-card--' + variant, 'app-card--padding-' + padding]">
  <ng-content></ng-content>
</section>